import type { WeatherKind } from '../data/fish';

export interface WeatherSave { kind: WeatherKind; remaining: number; index?: number; }
const labels: Record<WeatherKind, string> = { clear: '☀️ Açık', rain: '🌧 Yağmur', fog: '🌫 Sis', snow: '❄️ Kar' };
/** Oyun zamanı ile ilerleyen, world save'e yazılabilen hafif hava sistemi. */
export class WeatherSystem {
  kind: WeatherKind = 'clear';
  remaining = 360;
  private index = 0;
  update(dt: number): boolean { this.remaining -= dt; if (this.remaining > 0) return false; const cycle: WeatherKind[]=['clear','rain','fog','clear','snow']; this.kind=cycle[this.index++ % cycle.length]!; this.remaining=300 + (this.index % 3) * 90; return true; }
  load(save?: Partial<WeatherSave>): void {
    if (save && (save.kind==='clear'||save.kind==='rain'||save.kind==='fog'||save.kind==='snow')) {
      this.kind=save.kind;
      this.remaining=Number.isFinite(save.remaining)?Math.max(1,save.remaining!):360;
      if (Number.isSafeInteger(save.index) && save.index! >= 0) this.index=save.index!;
    }
  }
  toSave(): WeatherSave { return { kind:this.kind, remaining:this.remaining, index:this.index }; }
  get label(): string { return labels[this.kind]; }
}
